import { ApiService } from 'src/app/api.service';
import {
  Component,
  ElementRef,
  OnDestroy,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

import { AtributosComponent } from './atributos/atributos.component';
import { Subscription } from 'rxjs';
import { ZoomImageComponent } from './zoom-image/zoom-image.component';
import { ResizeService } from 'src/app/shared/services/resize.service';
declare var $: any;

@Component({
  selector: 'app-produtos-detalhe',
  templateUrl: './produtos-detalhe.component.html',
  styleUrls: ['./produtos-detalhe.component.scss'],
})
export class ProdutosDetalheComponent implements OnDestroy {
  @ViewChild('images', { static: false }) carrosselElement:
    | ElementRef
    | undefined;
  productDetails: any;
  allProducts: any;
  characteristics: any;
  attributes: any;
  productAttributes: any;
  productQualityTests: any;
  qualityTests: any;
  filteredCharacteristics: any;

  //carrosel
  fullArrayCarousel: any = [];
  carouselItems: any[] = [];
  clicked = false;
  carouselIndex = 0;
  carouselLength = 0;
  carouselCardWidth = 0;
  carouselInterval: any;
  carouselIntervalRestart: any;

  filteredVariants: any = [];
  listReferences: any = [];
  filteredAttributes: any = [];
  filteredRelateds: any;
  filteredQualityTests: any;
  filteredProductsAttributes: any;
  filteredProductsQualityTests: any;
  displayedColumns: string[] = ['codPro', 'desPro'];
  attributesExpanded: any[] = [];
  dataSource: any[] = [];
  routParam: string = '';
  routParamCodPro: string = '';
  breadcrumb: any;
  productCategory: any;
  expand = false;
  attributesAllVariants: any[] = [];

  startX: number = 0;
  endX: number = 0;
  private subscriptions: Subscription[] = [];
  public loadedImages: string[] | [] = [];
  public allImages: string[] = [];

  countRecursiveBreadCrumb = 0;

  isFirstLoad = true;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private apiService: ApiService,
    private el: ElementRef,
    private renderer: Renderer2,
    private resizeService: ResizeService,
    private elementRef: ElementRef
  ) {}

  ngOnInit() {
    if (history.state.data) {
      this.breadcrumb = history.state.data;
    }

    let routeSubscription = this.route.params.subscribe((params) => {

      this.routParam = params['slug'];
      this.loadData();
      if (!this.isFirstLoad) {
        this.breadcrumb = null;
      }
      this.isFirstLoad = false;
    });
    this.subscriptions.push(routeSubscription);
    addEventListener('resize', () => this.calcElementsInCarousel());
  }

  async getProductCategory() {
    this.productCategory = await this.apiService.loadProductsCategories();
  }

  private setDataSource(data: any) {
    this.dataSource = data;
  }

  private setCarouselItems(data: any[]) {
    this.carouselItems = data;
  }

  calcStart(event: any) {
    if ('changedTouches' in event) {
      this.startX = event.changedTouches[0].clientX;
    } else {
      this.startX = event.clientX;
    }
  }
  calcEnd(event: any) {
    if ('changedTouches' in event) {
      this.endX = event.changedTouches[0].clientX;
    } else {
      this.endX = event.clientX;
    }
    const deltaX = this.endX - this.startX;
    const carrossel = this.el.nativeElement.querySelector('#carouselBanners');

    $(carrossel).carousel();

    if (deltaX > 50) {
      $(carrossel).carousel('prev');
    } else if (deltaX < -50) {
      $(carrossel).carousel('next');
    }
  }

  onDragStart(event: Event): void {
    event.preventDefault();
  }

  async montarBreadcrumb(codPro: string) {
    if (!this.breadcrumb) {
      let catTemp = await this.productCategory;
      const categories = catTemp.filter((e: any) => e.codPro == codPro);
      if (categories.length > 0) {
        const codCat = categories[this.countRecursiveBreadCrumb]['codCat'];
        let subsubcategory: any = await this.apiService.loadProductLine(codCat);
        if (!subsubcategory) {
          this.countRecursiveBreadCrumb++;
          this.montarBreadcrumb(codPro);
          return;
        }
        let subcategory: any = await this.apiService.loadProductLine(
          subsubcategory.parent_id
        );
        let category: any = await this.apiService.loadProductLine(
          subcategory.parent_id
        );

        this.breadcrumb = {
          category: { name: category.nome, link: `linhas/${category.slug}` },
          subcategory: {
            name: subcategory.nome,
            link: `linhas/${category.slug}/${subcategory.slug}`,
          },
          subsubcategory: {
            name: subsubcategory.nome,
            link: `linhas/${category.slug}/${subcategory.slug}/${subsubcategory.slug}`,
          },
        };
      } else {
        this.breadcrumb = {
          category: '',
          subcategory: '',
          subsubcategory: '',
        };
      }
    }
  }

  loadProductImagesByCodPro(codPro: string, codEmp: string) {
    this.allImages = [];
    let getProductImagesSubscription = this.apiService
      .loadProductImages()
      .subscribe((data) => {
        let dataTemp = data.filter(
          (item) => item.codEmp == codEmp && item.codPro == codPro
        );
        this.loadedImages = dataTemp.map((item) => item.url_imagem);

        if (this.productDetails.IMGPR1)
          this.allImages.push(this.productDetails.IMGPR1);
        if (this.productDetails.IMGPR2)
          this.allImages.push(this.productDetails.IMGPR2);
        if (this.productDetails.IMGPR3)
          this.allImages.push(this.productDetails.IMGPR3);
        if (this.productDetails.IMGPR4)
          this.allImages.push(this.productDetails.IMGPR4);
        if (this.productDetails.IMGPR5)
          this.allImages.push(this.productDetails.IMGPR5);
        if (this.productDetails.IMGPR6)
          this.allImages.push(this.productDetails.IMGPR6);

        const combinedSet = new Set([...this.allImages, ...this.loadedImages]);
        this.allImages = Array.from(combinedSet);
        if (!this.allImages.length) {
          this.allImages = [
            'https://s3.sa-east-1.amazonaws.com/blukitsite.assets/produtos/imagens/imagem-indisponi%CC%81vel.jpg',
          ];
        }
      });
    this.subscriptions.push(getProductImagesSubscription);
  }

  calcElementsInCarousel() {
    const images = document.getElementById('images');
    const cardImage = document.querySelectorAll('.a-card')[0];
    if (images && cardImage) {
      const imageWidth = parseInt(
        window.getComputedStyle(cardImage).width.toString().split('px')[0]
      );
      const carouselWidth = parseInt(
        window.getComputedStyle(images).width.toString().split('px')[0]
      );
      let containerGap = parseInt(
        window.getComputedStyle(images).gap.toString().split('px')[0]
      );

      this.carouselCardWidth = containerGap + imageWidth;
      this.carouselLength =
        2 + Math.ceil(carouselWidth / this.carouselCardWidth);

      this.carouselItems = Array.from(this.fullArrayCarousel);
      while (this.carouselLength > this.carouselItems.length) {
        this.carouselItems = [...this.carouselItems, ...this.carouselItems];
      }

      let lastIndex = this.carouselLength + this.carouselIndex - 1;

      lastIndex =
        lastIndex > this.carouselItems.length
          ? lastIndex - this.carouselItems.length
          : lastIndex;

      if (
        this.carouselIndex + this.carouselLength - 1 >
        this.carouselItems.length
      ) {
        let carouselTemp1 = this.carouselItems.slice(
          this.carouselIndex,
          this.carouselItems.length - 1
        );
        let carouselTemp2 = this.carouselItems.slice(0, lastIndex);

        this.carouselItems = [...carouselTemp1, ...carouselTemp2];
      } else {
        this.carouselItems = this.carouselItems.slice(
          this.carouselIndex,
          lastIndex
        );
      }
      let previousIndex =
        this.carouselIndex - 1 < 0
          ? this.fullArrayCarousel.length - 1
          : this.carouselIndex - 1;
      this.carouselItems.unshift(this.fullArrayCarousel[previousIndex]);

      images?.classList.add('resetTranslate');
      images.style.setProperty(
        '--carousel-offset',
        '-' + this.carouselCardWidth + 'px'
      );
      setTimeout(() => {
        images?.classList.remove('resetTranslate');
      }, 1);
    }
  }

  previousCarouselItem() {
    this.carouselItems.pop();
    let lastIndex = this.carouselIndex - 2;
    if (lastIndex < 0) {
      lastIndex = this.fullArrayCarousel.length + lastIndex;
    }
    this.carouselItems.unshift(this.fullArrayCarousel[lastIndex]);
    this.carouselIndex =
      this.carouselIndex == 0
        ? this.fullArrayCarousel.length - 1
        : this.carouselIndex - 1;
  }

  buttonLeftTranslate() {
    this.previousCarouselItem();

    const images = document.getElementById('images');
    images?.classList.add('resetTranslate');

    images!.style.setProperty(
      '--carousel-offset',
      '-' + this.carouselCardWidth * 2 + 'px'
    );

    setTimeout(() => {
      images!.style.setProperty(
        '--carousel-offset',
        '-' + this.carouselCardWidth + 'px'
      );

      images?.classList.remove('resetTranslate');
    }, 20);
  }

  buttonLeftClicked() {
    this.clicked = true;
    setTimeout(() => {
      this.clicked = false;
      clearInterval(this.carouselInterval);
      this.restartIntervalAnimation();
    }, 400);

    this.buttonLeftTranslate();
  }

  nextCarouselItem() {
    this.carouselItems.shift();
    let lastIndex =
      (this.carouselIndex +
        (this.carouselItems.length % this.fullArrayCarousel.length)) %
      this.fullArrayCarousel.length;

    this.carouselItems.push(this.fullArrayCarousel[lastIndex]);
    if (this.carouselIndex >= this.fullArrayCarousel.length - 1) {
      this.carouselIndex = 0;
      lastIndex = 0;
    } else {
      this.carouselIndex++;
    }
  }

  buttonRightTranslate() {
    this.nextCarouselItem();
    const images = document.getElementById('images');
    images?.classList.add('resetTranslate');

    images!.style.setProperty('--carousel-offset', '0px');

    setTimeout(() => {
      images!.style.setProperty(
        '--carousel-offset',
        '-' + this.carouselCardWidth + 'px'
      );

      images?.classList.remove('resetTranslate');
    }, 20);
  }

  buttonRightClicked() {
    this.clicked = true;
    setTimeout(() => {
      this.clicked = false;
      clearInterval(this.carouselInterval);
      this.restartIntervalAnimation();
    }, 400);

    this.buttonRightTranslate();
  }

  startCarouselAnimation() {
    this.carouselInterval = setInterval(
      () => this.buttonRightTranslate(),
      4000
    );
  }

  getVideoIframeUrl(url: string) {
    var id = this.getVideoId(url);
    return 'https://www.youtube.com/embed/' + id + '';
  }

  getVideoId(url: string) {
    var exp =
      /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
    var varId = url.match(exp);
    if (varId != null) {
      return varId[1];
    }
    return '';
  }
  restartIntervalAnimation() {
    if (this.carouselIntervalRestart) {
      clearTimeout(this.carouselIntervalRestart);
    }
    this.carouselIntervalRestart = setTimeout(() => {
      this.startCarouselAnimation();
    }, 6000);
  }

  async loadData() {
    clearInterval(this.carouselInterval);
    clearTimeout(this.carouselIntervalRestart);
    await this.getProductCategory();
    await this.loadProductDetail();
    await this.filterReferences();
    this.setDataSource(this.listReferences);

    this.loadProductImagesByCodPro(
      this.productDetails.codPro,
      this.productDetails.codEmp
    );
    await this.loadCharacteristics();
    await this.loadQualityTests();
    await this.loadPrductAttributes();
    await this.loadPrductQualityTests();
    await this.loadAttributes();

    await this.setFullArrayCarousel();
    this.setCarouselItems(this.fullArrayCarousel);

    setTimeout(() => {
      this.calcElementsInCarousel();
      this.startCarouselAnimation();
      this.allProducts = [];
    }, 10);
    this.prepareDataVariants();
  }

  filterRelateds(): any[] {
    let groupRelateds = this.productDetails.grupo_relacionamento;
    if (!groupRelateds) return [];
    let data = this.allProducts.filter(
      (prod: any) =>
        prod.grupo_relacionamento == groupRelateds &&
        !(
          prod.codPro == this.productDetails.codPro &&
          prod.codEmp == this.productDetails.codEmp
        )
    );
    return data;
  }

  private async getCategoriesOfAProduct(codPro: string, codEmp: string) {
    let categoriesProducts = this.productCategory.filter(
      (category: any) => category.codPro == codPro && category.codEmp == codEmp
    );
    let categories = categoriesProducts.map((category: any) => category.codCat);
    return categories as string[];
  }

  private removeCurrentProduct(array: any[]) {
    return array.filter(
      (item) =>
        !(
          item.codPro == this.productDetails.codPro &&
          item.codEmp == this.productDetails.codEmp
        )
    );
  }

  private verifyProductExistsInArray(array: any[], product: any): boolean {
    let exist = array.find(
      (item) => item.codPro == product.codPro && item.codEmp == product.codEmp
    );
    return exist ? true : false;
  }

  private async tryReturnAValidCategoryByArrayOfCategories(
    categories: string[]
  ) {
    let cat: any;
    let count = 0;

    while (!cat && count < categories.length) {
      let catTemp: any = await this.apiService.loadProductLine(
        categories[count]
      );
      if (catTemp) {
        cat = catTemp;
      }
      count++;
    }

    return cat as string;
  }

  async setFullArrayCarousel() {
    let arrayRelateds = this.filterRelateds();

    const combinedSet = new Set([...this.listReferences, ...arrayRelateds]);
    this.fullArrayCarousel = Array.from(combinedSet);

    // If the length is still < 5, try feeds the array with products
    // of the same category or subcategory
    if (this.fullArrayCarousel.length < 5) {
      let categories = await this.getCategoriesOfAProduct(
        this.productDetails.codPro,
        this.productDetails.codEmp
      );

      if (categories.length > 0) {
        let cat = this.tryReturnAValidCategoryByArrayOfCategories(categories);

        if (cat) {
          let moreProducts = await this.returnMoreProductsByCategory(cat);

          if (moreProducts && moreProducts.length > 0) {
            let temp = [...this.fullArrayCarousel, ...moreProducts];
            this.fullArrayCarousel = temp;
          }
        }
      }
    }
    // If even so the length is still < 5, get 8 random products
    if (this.fullArrayCarousel.length < 8) {
      let randomProducts = this.getRandomProductsExcpetTheCurrentProduct(8);
      this.fullArrayCarousel = [...this.fullArrayCarousel, ...randomProducts];
    }
    this.fullArrayCarousel = this.removeCurrentProduct(this.fullArrayCarousel);

    if (this.fullArrayCarousel.length > 8) {
      this.fullArrayCarousel = this.fullArrayCarousel.slice(0, 8);
    }

    this.fullArrayCarousel.map(async (i: any) => {
      if (i.IMGPR1) {
        i.resizedImageUrl = await this.resizeService.getUrlResized(i.IMGPR1);
      } else {
        i.resizedImageUrl =
          'https://s3.sa-east-1.amazonaws.com/blukitsite.assets/produtos/imagens/imagem-indisponi%CC%81vel.jpg';
      }
    });
  }

  private getRandomProductsExcpetTheCurrentProduct(quantity: number) {
    let newProducts = [];
    while (newProducts.length < quantity) {
      let randomIndex = Math.floor(Math.random() * this.allProducts.length);
      let tempProduct = this.allProducts[randomIndex];
      if (
        !(
          tempProduct.codPro == this.productDetails.codPro &&
          tempProduct.codEmp == this.productDetails.codEmp
        ) &&
        tempProduct.IMGPR1 &&
        !this.verifyProductExistsInArray(newProducts, tempProduct)
      ) {
        newProducts.push(tempProduct);
      }
    }
    return newProducts;
  }

  async filterReferences() {
    if (!this.productDetails) return;
    this.listReferences = [];

    let grupo_variante = this.productDetails.grupo_variante;
    this.listReferences.push(this.productDetails);

    if (grupo_variante) {
      let listTemp = this.allProducts.filter((res: any) => {
        return (
          res.grupo_variante == grupo_variante &&
          !(
            res.codPro == this.productDetails.codPro &&
            res.codEmp == this.productDetails.codEmp
          )
        );
        // return grupo_variante.indexOf(res.grupo_variante) > -1 && (res.slug != this.routParam);
        });
        this.listReferences = [...this.listReferences, ...listTemp];
        }
  }

  async returnMoreProductsByCategory(cat: any) {
    let products = await this.apiService.getFilteredProductsByCategories(
      cat.id
    );
    products = products.filter(
      (product: any) => product.codPro !== this.productDetails.codPro
    );

    if (products && products.length > 5) {
      return products;
    }

    if (cat.parent_id) {
      let category: any = await this.apiService.loadProductLine(cat.parent_id);

      if (category && category.subcategorias) {
        let subCategories = category.subcategorias;

        for (const c of subCategories) {
          let subCategoryProducts =
            await this.apiService.getFilteredProductsByCategories(c.id);

          if (subCategoryProducts.length > 0) {
            subCategoryProducts.forEach((productTemp) => {
              let addProduct = !products.some(
                (product) => productTemp.codPro === product.codPro
              );
              if (
                addProduct &&
                productTemp.codPro != this.productDetails.codPro
              ) {
                products.push(productTemp);
              }
            });
          }
        }
      }
    }
    return products;
  }

  filterCharacteristics() {

    if (this.productDetails && this.characteristics) {

        var arrayTemp = JSON.parse(
          '[' + this.productDetails.caracteristicas + ']'
        );
        this.filteredCharacteristics = this.characteristics.filter((res: any) => {
          return arrayTemp.indexOf(res.id) > -1;
        });

    }
  }

  filterProductAttributes() {
    if (this.productDetails && this.productAttributes) {
      this.filteredProductsAttributes = this.productAttributes.filter(
        (res: any) => res.codPro === this.productDetails.codPro
      );
    }
  }
  filterProductQualityTests() {
    if (this.productDetails && this.productQualityTests && this.qualityTests) {
      this.filteredProductsQualityTests = [];
      this.productQualityTests.map((elem: any) => {
        if (elem.codPro === this.productDetails.codPro) {
          this.filteredProductsQualityTests.push(elem.teste_qualidade_id);
        }
      });

      this.filteredQualityTests = this.qualityTests.filter((res: any) => {
        return this.filteredProductsQualityTests.indexOf(res.id) > -1;
      });
    }
  }
  filterAttributes() {
    if (this.productDetails && this.attributes) {
      this.filteredProductsAttributes.map((elem: any) => {
        this.attributes.forEach((element: any) => {
          if (elem.atributoId === element.id) {
            elem.nome = element.nome;
          }
        });
      });
    }
  }

  async loadProductDetail() {
    this.allProducts = await this.apiService.loadProducts();
    this.productDetails = this.allProducts.filter(

      (res: any) => {
        return res.slug === this.routParam || res.codPro === this.routParam
      }
    );

    if (this.productDetails.length > 0) {
      this.productDetails = this.productDetails[0];
      this.montarBreadcrumb(this.productDetails.codPro);
    } else{
      this.productDetails = undefined
    }
    this.filterCharacteristics();
  }
  async loadCharacteristics() {
    this.characteristics = await this.apiService.loadCharacteristics();
    this.filterCharacteristics();
  }
  async loadQualityTests() {
    this.qualityTests = await this.apiService.loadQualityTests();
  }
  async loadPrductQualityTests() {
    this.productQualityTests = await this.apiService.loadPrductQualityTests();
    this.filterProductQualityTests();
  }

  async loadPrductAttributes() {
    this.productAttributes = await this.apiService.loadPrductAttributes();
    this.filterProductAttributes();
  }
  async loadAttributes() {
    this.attributes = await this.apiService.loadAttributes();
    this.filterAttributes();
  }

  prepareDataVariants() {
    let atributos: any[] = [];

    this.displayedColumns = ['codPro', 'desPro'];

    this.listReferences.forEach((ref: any, index: any) => {
      let atributosTemp = this.filterAttributesById(ref.codPro, ref.codEmp);

      this.sortAttributes(atributosTemp);

      this.dataSource[index].atributos = atributosTemp;
      atributos = [...atributos, ...atributosTemp];
      });
      this.attributesAllVariants = atributos;

    const arraySemDuplicados = atributos.filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.atributoId === item.atributoId)
    );

    this.sortAttributes(arraySemDuplicados);
    let atributosNome = [];
    atributosNome = arraySemDuplicados.map((n) => n.nome);

    this.attributesExpanded = arraySemDuplicados;
    this.displayedColumns = [...this.displayedColumns, ...atributosNome];

  }

  getAttributeValue(attributeId: string, codPro: string, codEmp: string) {
    let attribute = this.attributesAllVariants.find(
      (a) =>
        a.atributoId == attributeId && a.codPro == codPro && a.codEmp == codEmp
    );
    return attribute ? attribute.valor : '--';
  }
  sortAttributes(attributes: any[]) {
    attributes.sort(
      (a: { ordem: number; nome: string }, b: { ordem: number; nome: any }) => {
        return a.ordem - b.ordem || a.nome.localeCompare(b.nome);
      }
    );
    return attributes;
  }
  filterAttributesById(codPro: string, codEmp: string) {
    let attributes = this.productAttributes.filter(
      (item: any) => item.codEmp == codEmp && item.codPro == codPro
    );
    attributes.map((elem: any) => {
      this.attributes.forEach((element: any) => {
        if (elem.atributoId === element.id) {
          elem.nome = element.nome;
        }
      });
    });
    return attributes;
  }

  openDialog(url: string) {
    document.body.classList.add('no-scroll');
    const dialogRef = this.dialog.open(ZoomImageComponent, {
      width: '100%',
      height: '100%',
      minHeight: '100%',
      minWidth: '100%',
      data: url,
      panelClass: 'bk-dialog',
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }
  openDialogBanners() {
    document.body.classList.add('no-scroll');
    let image = document.querySelector(
      '.carousel-item.active .crop canvas'
    ) as HTMLImageElement;
    const dialogRef = this.dialog.open(ZoomImageComponent, {
      width: '100%',
      height: '100%',
      minHeight: '100%',
      minWidth: '100%',
      data: image.getAttribute('url'),
      panelClass: 'bk-dialog',
      autoFocus: false,
    });
    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }

  openDialogAttributes(codPro: string, codEmp: string) {
    document.body.classList.add('no-scroll');
    const dialogRef = this.dialog.open(AtributosComponent, {
      width: 'auto',
      height: 'auto',
      minHeight: '50vh',
      minWidth: '50vw',
      maxHeight: '90vh',
      data: this.filterAttributesById(codPro, codEmp),
      autoFocus: false,
    });

    dialogRef.afterClosed().subscribe(() => {
      document.body.classList.remove('no-scroll');
    });
  }
  verificarPrefixo(resposta: string) {
    const prefixo = 'https://';

    if (resposta.startsWith(prefixo)) {
      return true;
    } else {
      return false;
    }
  }
  downloadFile(file: string) {
    if (file) {
      window.open(file, '_blank');
    } else {
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    clearInterval(this.carouselInterval);
    clearTimeout(this.carouselIntervalRestart);
  }
}
